<div class="content-class" [style.filter]="blurPage == true ? 'blur(0.2rem)' : 'blur(0)'">
  <div class="content-block">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutGap="10px" class="tap-bloc-style">
        <abc-button
          [stylingMode]="'text'"
          [text]="dataService.res('Ubt-SubProject-Create-Company')"
          [template]="'buttonTemplate'"
          [useSubmitBehavior]="false"
          [style]="{
            'background-color': appService.isCompanySelected ? 'var(--secondary-color)' : 'var(--primary-color)'
          }"
          class="abc-button-style"
        >
          <div *dxTemplate="let tab of 'buttonTemplate'">
            <div class="button-content" id="0" (click)="redirectToCompanies()">
              <img class="icon-style" [src]="'assets/images/right-arrow.svg'" alt="NotificationA" />

              <div>{{ dataService.res('Ubt-SubProject-Create-Company') }}</div>
            </div>
          </div>
        </abc-button>

        <abc-button
          *ngIf="appService.isCompanySelected"
          [stylingMode]="'text'"
          [text]="dataService.res('Company-Select-Project')"
          [template]="'buttonTemplate'"
          [useSubmitBehavior]="false"
          class="abc-button-style"
        >
          <div *dxTemplate="let tab of 'buttonTemplate'">
            <div class="button-content" id="1">
              <img class="icon-style" [src]="'assets/images/right-arrow.svg'" alt="NotificationA" />

              <div>{{ dataService.res('Company-Select-Project') }}</div>
            </div>
          </div>
        </abc-button>
      </div>
    </div>
    <div fxFill fxLayout="row wrap" fxLayoutGap="10px" fxLayoutAlign="space-between none">
      <div fxFill fxLayout="column" fxFlex="68" fxFlex.sm="100" fxLayoutAlign="space-between none">
        <div id="searchBloc" fxLayout="column" fxFlex="15" class="filter-card">
          <div class="card-container">
            <div fxFill fxLayout="row" fxLayoutAlign="space-evenly stretch" fxLayoutGap="5px">
              <div fxLayout="column" fxFlex="60">
                <abc-text-box
                  class="search"
                  placeholder="{{ res('Company-Icon-Search') }}"
                  [mode]="'search'"
                  stylingMode="outlined"
                  labelMode="floating"
                  valueChangeEvent="keyup"
                  (onValueChanged)="resetSearch($event)"
                  (input)="searchTerm.next($event.target.value)"
                >
                </abc-text-box>
              </div>
              <div fxLayout="column" fxFlex="40">
                <abc-select-box
                  #filterField
                  class="select-box-filter"
                  [stylingMode]="'outlined'"
                  [labelMode]="'floating'"
                  displayExpr="name"
                  valueExpr="id"
                  [items]="filterOptions"
                  (onItemClick)="selectFilterOption($event)"
                >
                </abc-select-box>
              </div>
            </div>
          </div>
        </div>
        <div class="card-container" fxFlex="85">
          <company-card
            *ngIf="!appService.isCompanySelected"
            id="companies"
            style="display: block"
            [companies]="companies"
            [filterActive]="filterActive"
            [navigateUrl]="navigateUrl"
            [companyIdDependency]="companyIdDependency"
            [companyNameDependency]="companyNameDependency"
            [configDependencies]="configDependencies"
            (clickCompany)="clickCompanyAction($event)"
            (selectCompany)="hoverCompanyAction($event)"
            [title]="selectedCompany"
          >
          </company-card>

          <div *ngIf="appService.isCompanySelected">
            <div fxLayout="row" fxLayoutAlign="space-between none" class="card-heigh">
              <div fxFlex="100" fxLayout="column">
                <div
                  content
                  gdColumns="repeat(2, 1fr)"
                  gdColumns.gt-md="repeat(2, 1fr)"
                  gdRows="repeat(2, 1fr)"
                  gdRows.gt-md="repeat(2, 1fr)"
                  gdGap="5px"
                >
                  <div
                    class="project-card project-of-company"
                    fxLayoutAlign="space-between none"
                    (click)="navigateToDashboard(project)"
                    *ngFor="let project of appService.projectList"
                  >
                    <div fxLayout="column" fxFlex="100">
                      <div fxFill fxLayout="column" fxFlex="65">
                        <div fxFill fxLayout="row">
                          <div fxLayout="column" fxFlex="70">
                            <div fxLayout="row">
                              <div class="project-title">
                                <span> {{ project.Label }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div fxLayout="row" fxFlex="40" fxLayoutAlign="space-between none">
                        <div fxLayout="row" fxFlex="33" fxLayoutAlign="center center">
                          <div class="item-style">
                            {{ dataService.res('Company-Sub-Project') }} {{ project.subProjectsCount }}
                          </div>
                        </div>
                        <div fxLayout="row" fxFlex="33" fxLayoutAlign="center center">
                          <div class="item-style">
                            {{ dataService.res('Company-Measures') }} {{ project.measuresCount }}
                          </div>
                        </div>
                        <div fxLayout="row" fxFlex="33" fxLayoutAlign="center center">
                          <div class="item-style">
                            {{ dataService.res('Company-Milestones') }} {{ project.tasksCount }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div fxFill fxLayout="row" fxFlex="30" fxFlex.sm="100" fxFlex.xs="100">
        <div class="card-container">
          <abc-accordion
            class="accordion-style implement-plain-container"
            [collapsible]="true"
            [selectedIndex]="1"
            [width]="'100%'"
            [animationDuration]="300"
            [visible]="true"
            [multiple]="false"
            [dataSource]="['Test']"
          >
            <div *dxTemplate="let implementationPlan of 'title'" class="dx-accordion-item-title">
              {{ dataService.res('Company-My-Most-Recently-Worked-Projects') }}
            </div>
            <div *dxTemplate="let company of 'item'">
              <div class="last-project-updated">>{{ dataService.res('Company-My-Most-Recently-Worked-Projects') }}</div>
              <project-card (selectLastProjectUpdated)="selectLastProjectUpdatedAction($event)"> </project-card>
            </div>
          </abc-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
